<div id="toxicologyExpectedResults" style="padding: 8px" [style.display]="hasResults ? 'block' : 'none'">
    <div style="text-align: center; background-color: rgba(172,0,12,0.27); height: 24px" [ngStyle.xs]="{height: '40px'}">
        <h5 style="height: 24px">Inconsistent Results - Positive Results For Drugs Not Reported</h5>
    </div>
    <dx-tree-list
        #toxiUnexpectedPositiveTree
        [dataSource]="dataSource"
        dataStructure="tree"
        itemsExpr="tests"
        keyExpr="treeId"
        [showRowLines]="true"
        [hoverStateEnabled]="true"
        [showBorders]="true"
        [highlightChanges]="true"
        [columnAutoWidth]="true"
        height='100%'
        [allowColumnResizing]="true"
        [columnHidingEnabled]="isPhoneOrTablet">
        <dxi-column caption="Test" dataField="name" [hidingPriority]="isPhoneOrTablet ? 2 : -1"></dxi-column>
        <dxi-column dataField="result" caption="Amount Detected" [hidingPriority]="isPhoneOrTablet ? 1 : -1"></dxi-column>
        <dxi-column dataField="detectionWindow" caption="Typical Detection Window" [hidingPriority]="isPhoneOrTablet ? 0 : -1"></dxi-column>
    </dx-tree-list>
</div>
